<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section v-if="!error && loaded && task && task.taskStatus !== TASK_STATUS.SUCCESSFULLY_COMPLETED.value">

            <div class="grid-x grid-margin-x">
                <div class="cell small-12">

                    <h1 class="text-2xl font-bold">Company Contacts</h1>
                    <p>Please provide the details of the company contact(s) for your company.</p>

                    <EditableTable
                    v-model="payrollContacts"
                    :columns="columns"
                    :buttonName="'Add Contact'"
                    />
                  </div>
                </div>
                              <br/>
              <button class="btn btn-primary" v-if="payrollContacts.length > 0" @click="saveContacts">Finalise Contacts</button>
              </section>
              <section v-else>
                <div class="grid-x grid-margin-x">
                  <div class="cell small-12">
                    <h1 class="text-2xl font-bold">Company Contacts</h1>
                    <p>Thank you for providing your company contacts, this information is currently being reviewed by our team.</p>
                    
                    <table v-if="contactsResponse && contactsResponse.length">
                      <thead>
                        <tr>
                          <th>Forename</th>
                          <th>Surname</th>
                          <th>Email</th>
                          <th>Payroll Contact</th>
                          <th>Billing Contact</th>
                          <th>BACS Contact</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(contact, index) in contactsResponse" :key="index">
                          <td>{{ contact.contactForenameName }}</td>
                          <td>{{ contact.contactSurnameName }}</td>
                          <td>{{ contact.contactEmail }}</td>
                          <td>{{ formatToYesNo(contact.isPayrollContact) }}</td>
                          <td>{{ formatToYesNo(contact.isBillingContact) }}</td>
                          <td>{{ formatToYesNo(contact.isBACSContact) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
                  </div>  
                </div>
              </section>



            </div>

          </section>
          </template>

          <script setup>
          import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useClientStore } from '@/stores/client'
import EditableTable from '@/components/controls/EditableTable.vue';
import { putDataCollectionTask, getDataCollectionTask } from '@/services/implementationmanagement.api';
import { TASK_STATUS } from '@/helpers/constants';
import { formatToYesNo } from '@/helpers/boolean';

const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const task = ref(null);

const columns = [
  { field: 'contactForenameName', label: 'Forename', type: 'text', placeholder: 'Forename' },
  { field: 'contactSurnameName', label: 'Surname', type: 'text', placeholder: 'Surname' },
  { field: 'contactEmail', label: 'Email', type: 'text', placeholder: 'Email' },
  { field: 'isPayrollContact', label: 'Payroll Contact', type: 'checkbox' },
  { field: 'isBillingContact', label: 'Billing Contact', type: 'checkbox' },
]


const signupContacts = ref(null);
const payrollContacts = ref([]);
const contactsConfirmed = ref(false);
const contactsResponse = ref(null);

const errorString = 'An error has occurred. Please contact your Qtac account manager.';


onMounted(async () => {

    if (!columns.find(c => c.field === 'isBACSContact')) {
        columns.push({ field: 'isBACSContact', label: 'BACS Authoriser', type: 'checkbox' });
    }

    const client = useClientStore();

    signupContacts.value = client.contacts?.find(c => c.isSlaSignatory === true) || null;

    // Initialize payrollContacts from signupContacts (support single object or array)
    if (signupContacts.value) {
        const list = Array.isArray(signupContacts.value) ? signupContacts.value : [signupContacts.value];
        payrollContacts.value = list.map(c => ({
            //contactName: [c?.firstName, c?.lastName].filter(Boolean).join(' '),
            contactForenameName: c?.firstName || '',
            contactSurnameName: c?.lastName || '',
            contactEmail: c?.email || '',
            // preserve boolean flags if present, default to false
            isPayrollContact: !!c?.isPayrollContact,
            isBillingContact: !!c?.isBillingContact,
            isBACSContact: !!c?.isBACSContact
        }));
    } else {
        payrollContacts.value = [];
    }


    var response = await getDataCollectionTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
      error.value = errorString;
      return null;
    }

    task.value = response.data;

    try {

      // If dataJson is empty string then set accoridingly, otherwise parse it
      if(!task.value.dataJson || task.value.dataJson.trim() === "") {
        contactsResponse.value = "";
        loaded.value = true;
        return;
      }

      contactsResponse.value = JSON.parse(task.value.dataJson);

          
  } catch (e) {
    error.value = "Failed to parse questionnaire data";
    return;
  }

  loaded.value = true;


})

const saveContacts = async () => {
  var payload = {
    version: 1,
    dataJson: JSON.stringify(payrollContacts.value),
    schemaName: "CompanyContacts",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }

  router.back();

}

</script>

